import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Up next; each part uses its own slice of it */
import styles from './UpNext.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The live label with a pulse dot (design s: "Writing 2 of 3", "Sending"). */
const LiveLabelComponent: React.FC<{ text: string; positive?: boolean }> = ({ text, positive = false }) => (
  <span className={clsx(styles.live, positive && styles.livePos)}>
    <i className={styles.dot} aria-hidden />
    {text}
  </span>
);

export const LiveLabel = TypedMemo(LiveLabelComponent);
